import { render, staticRenderFns } from "./CreateBuildingsButton.vue?vue&type=template&id=5fa79cdd&scoped=true&"
import script from "./CreateBuildingsButton.vue?vue&type=script&lang=ts&"
export * from "./CreateBuildingsButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBuildingsButton.vue?vue&type=style&index=0&id=5fa79cdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa79cdd",
  null
  
)

export default component.exports